'use client'

import { Box, Container, Grid, Paper, Stack, Typography } from '@mui/material'
import { ReactElement } from 'react'

export const FeaturesSection = (): ReactElement => {
	// Data sekarang didefinisikan di sini (di komponen induk), bukan di dalam SellerSteps.

	const featureCards = [
		{
			id: 1,
			color: '#00D5BE',
			title: 'Registrasi & Pengaturan Toko dengan Cepat',
			description: 'Buka toko online Anda di platform kami dalam hitungan menit. Unggah logo, deskripsi toko, dan langsung siap berjualan. Tanpa ribet!',
			iconUrl: '/assets/images/feature/quick-registration.svg'
		},
		{
			id: 2,
			color: '#51A2FF',
			title: 'Manajemen Produk & Stok yang Efisien',
			description: 'Upload produk tanpa batas, atur harga, variasi, deskripsi lengkap, dan kelola ketersediaan stok dengan mudah melalui dasbor penjual yang intuitif',
			iconUrl: '/assets/images/feature/efficient-mgmt.svg'
		},
		{
			id: 3,
			color: '#FF6467',
			title: 'Jangkauan Pelanggan Luas Se-Indonesia',
			description: 'Produk Anda akan dilihat oleh ribuan (atau jutaan) pengunjung platform kami setiap harinya. Perluas pasar Anda tanpa biaya pemasaran besar.',
			iconUrl: '/assets/images/feature/wide-coverage.svg'
		}
	]

	return (
		<section id='feature-container'>
			<Box className='py-56'>
				<Container maxWidth='lg'>
					<Stack spacing={8} alignItems='center' sx={{ width: '100%' }}>
						<Typography variant='h3' align='center' fontWeight={700} className='text-3xl sm:text-[40px] mb-16'>
							Beragam fitur untuk menunjang Bisnis <span className='font-extrabold text-green-umkms'>UMKM</span> Anda
						</Typography>

						<Grid container spacing={4} justifyContent='center' sx={{ px: { xs: 2, md: 8 }, py: 3 }}>
							{featureCards.map((card) => (
								<Grid
									key={card.id}
									size={{
										xs: 12,
										sm: 6,
										md: 4
									}}>
									<Paper
										elevation={1}
										sx={{
											display: 'flex',
											flexDirection: 'column',
											gap: 1.5,
											p: 4,
											height: '100%',
											borderRadius: '24px',
											position: 'relative',
											overflow: 'hidden',
											alignItems: { xs: 'center', md: 'flex-start' },
											textAlign: { xs: 'center', md: 'left' }
										}}>
										<Box component='img' src={card.iconUrl} alt='Icon' className='w-16 h-auto' />

										<Typography variant='h6' className='font-bold text-xl text-black'>
											{card.title}
										</Typography>

										<Typography variant='body2' className='font-normal text-xs text-black leading-5'>
											{card.description}
										</Typography>
									</Paper>
								</Grid>
							))}
						</Grid>
					</Stack>
				</Container>
			</Box>
		</section>
	)
}
